// HelpIcon.js - Thin wrapper around Tooltip for contextual "?" help icons
import React from 'react';
import Tooltip from './Tooltip';
import './HelpIcon.css';

function HelpIcon({ content, learnMorePath, category = 'context' }) {
  const tooltipContent = learnMorePath
    ? `${content}`
    : content;

  return (
    <Tooltip content={tooltipContent} category={category}>
      <span className="help-icon" aria-label="Help" role="img">?</span>
    </Tooltip>
  );
}

export default HelpIcon;
